module.exports = __webpack_public_path__ + "img/fb.e1a63cac.svg";